export const trackUserRole = (role = "guest") => {
  if (window.gtag) {

    // ✅ Set GA4 user property
    window.gtag("set", "user_properties", {
      user_role: role,
    });

    // ✅ Send page view
    window.gtag("event", "page_view", {
      user_role: role,
    });
  }
};